import { z } from 'zod';
// Response of POST /api/v1/auth/login-connect.
// Schema verified against the live API on 2026-04-07.
//
// NOTE (admin discovery phase): `role` is intentionally kept as a free-form
// `z.string()` for now so we can observe whatever value the backend returns for
// an admin account. Once confirmed, this is pinned to `z.enum(['ADMIN', ...])`
// and the login gate is hardened to reject non-admins (see auth hooks).
export const LoginResponseSchema = z.object({
    success: z.boolean(),
    errorCode: z.string(),
    message: z.string(),
    data: z.object({
        accessToken: z.string(),
        refreshToken: z.string(),
        user: z.object({
            _id: z.string(),
            fullname: z.string().nullable(),
            email: z.string().nullable(),
            avatar: z.string(),
            username: z.string(),
            role: z.string(),
            membership: z.string(),
            isOnboarding: z.boolean(),
            isConnectedDevice: z.boolean(),
            gender: z.string(),
            anonId: z.string(),
            height: z.number().nullable(),
            weight: z.number().nullable(),
            startVip: z.string().nullable(),
            endVip: z.string().nullable(),
        }),
    }),
    meta: z.record(z.string(), z.unknown()),
});
// Normalized user identity stored in the auth store.
// Raw API fields _id and fullname are remapped to uid and displayName in useLogin().
export const AuthUserSchema = z.object({
    uid: z.string(),
    email: z.string().nullable(),
    displayName: z.string().nullable(),
    avatar: z.string(),
    username: z.string(),
    role: z.string(),
    membership: z.string(),
});
